export default __webpack_public_path__ + "static/media/homepage-icon.6bf0f6f5.svg";